<template>
    <div class="row" :style="rowStyle">
        <div class="form-inline col-md-2">
            <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                    <v-btn
                        icon
                        v-bind="attrs"
                        v-on="on"
                    >
                        <v-icon color="grey lighten-1" class="tooltip-small">
                            mdi-information-outline
                        </v-icon>
                    </v-btn>
                </template>
                <span>If you want to perform frequency analysis by day part, choose this option.</span>
            </v-tooltip>

            <i class="fas fa-wave-square"></i> <span style="padding-left: 5px;">Day part Freq</span>
        </div>
        <div class="form-group col-md-4 push-down-36">
            <v-switch
                v-model="day_part"
                inset
                label="Frequency by Day part"
                :disabled="is_day_part_frequency_analysis_allowed"
            ></v-switch>
        </div><!--form-group-->
    </div>
</template>

<script>
import analyses from "../../../../../mixin/analyses";

export default {
    name: "Frequency",
    mixins: [analyses],
    props: [
        'rowStyle'
    ],
    data: () => ({
        //
    }),
    methods: {
        //
    },
    created() {
        //
    },
    mounted() {
        //
    },
    computed: {
        is_day_part_frequency_analysis_allowed() {
            return !this.$store.getters.getUserPermissions.includes('feature-activation-analyses-frequency') ||
                (
                    this.$store.getters['CreateAudienceStore/getAnalysisType'](0) === this.analyses.types.apps ||
                    this.$store.getters['CreateAudienceStore/getAnalysisType'](1) === this.analyses.types.apps
                )
        },
        day_part: {
            get() {
                return this.$store.getters['CreateAudienceStore/getAnalysesFrequencyIsDayPart']
            },
            set(value) {
                this.$store.commit('CreateAudienceStore/SET_ANALYSES_FREQUENCY_DAY_PART', value)
            }
        }
    },
    watch: {
        //
    }
}
</script>

<style scoped>

</style>